import React from 'react'
import { ButtonHLPure } from '../../pures'

const ContractorsCatalogAddContractor = (props) => {

    let {
        hideShowDetails,
        paramsId,
    } = props

    let typePerson = (paramsId && paramsId === 2) ? 'proveedor' : 'contrante'
    return (
        <>
            <h1>{`Pantalla de agregar ${typePerson}`}</h1>
            <ButtonHLPure 
                nameBtn = {'Regresar'}
                primary = {false}
                onClickBtn = {hideShowDetails}
            />
        </>
    )
}

export default ContractorsCatalogAddContractor